/* Camas prontas — tamanho único na barra, peças removíveis, total e compra com cupom.
   Dados (variantes, preço em centavos, disponibilidade) vêm do JSON que a seção serializa. */
(function () {
  'use strict';

  var CHAVE_TAMANHO = 'hoomy_camas_prontas_tamanho';
  var TAMANHOS = ['Solteiro', 'Casal', 'Queen', 'King'];

  /* Tamanho da barra -> valor da opção Tamanho de cada peça */
  var MAPA_TAMANHO = {
    lencol: { Solteiro: 'Solteiro Especial', Casal: 'Casal', Queen: 'Queen', King: 'King' },
    capa: { Solteiro: 'Solteiro', Casal: 'Casal', Queen: 'Queen', King: 'King' },
    fronha: { Solteiro: 'Normal', Casal: 'Normal', Queen: 'Normal', King: 'King' }
  };

  var NOME_PECA = {
    lencol: 'Jogo de lençol',
    capa: 'Capa de edredom',
    fronha: 'Kit de fronhas da frente',
    toalha: 'Jogo de toalhas',
    tapete: 'Tapete',
    roupao: 'Roupão'
  };

  /* Cor da variante -> nome em português [masculino, feminino] */
  var COR_PT = {
    'White': ['branco', 'branca'],
    'Cloud Dancer': ['bege', 'bege'],
    'Mocha': ['marrom caramelo', 'marrom caramelo'],
    'Light Green': ['verde sálvia', 'verde sálvia'],
    'Azul Hoomy': ['azul-marinho', 'azul-marinho'],
    'Rose': ['rosa antigo', 'rosa antigo'],
    'Beige': ['bege', 'bege'],
    'Green': ['verde-garrafa', 'verde-garrafa'],
    'Light Rose': ['rosa-claro', 'rosa-claro']
  };
  var FEMININO = { capa: true };

  var TAMANHOS_ROUPAO = ['P', 'M', 'G'];

  /* Desconto que o motor da loja concede, medido no carrinho em 23/10/2026: 20% em cada peça
     quando o grupo tem 2 ou mais peças no pedido, e o Pix tira mais 2% no checkout (22% no selo).
     Cama: quaisquer 2 entre lençol, capa e fronha. Banho: só toalha + roupão; o tapete não entra. */
  var GRUPOS_DESCONTO = [['lencol', 'capa', 'fronha'], ['toalha', 'roupao']];
  var PCT_FAIXA = 20;
  var PCT_PIX = 2;

  /* A Shopify arredonda a alocação por unidade para baixo */
  function comFaixa(centavos) {
    return centavos - Math.floor(centavos * PCT_FAIXA / 100);
  }

  function lerTamanho() {
    try {
      var t = window.localStorage.getItem(CHAVE_TAMANHO);
      return TAMANHOS.indexOf(t) >= 0 ? t : 'Queen';
    } catch (e) {
      return 'Queen';
    }
  }

  function gravarTamanho(t) {
    try { window.localStorage.setItem(CHAVE_TAMANHO, t); } catch (e) { /* sem storage: segue sem lembrar */ }
  }

  function dinheiro(centavos) {
    var v = (centavos || 0) / 100;
    return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function evento(nome, dados) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: nome };
    for (var k in dados) payload[k] = dados[k];
    window.dataLayer.push(payload);
  }

  function cookie(nome) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + nome + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function iniciar(raiz) {
    var sid = raiz.getAttribute('data-section-id');
    var elDados = document.getElementById('cp-dados-' + sid);
    if (!elDados) return;
    var dados;
    try { dados = JSON.parse(elDados.textContent); } catch (e) { return; }

    var estado = { tamanho: lerTamanho(), filtro: 'todas' };

    /* Faixa do cupom: só quando o cupom já está ativo na sessão (cookie do link de desconto) */
    var faixa = raiz.querySelector('[data-cp-faixa]');
    if (faixa && dados.cupom && cookie('discount_code').toUpperCase() === dados.cupom) faixa.hidden = false;

    function acharVariante(chave, cor, tamanho) {
      var p = dados.produtos[chave];
      if (!p || !p.variantes) return null;
      for (var i = 0; i < p.variantes.length; i++) {
        var v = p.variantes[i];
        if (v.cor === cor && (tamanho == null || v.tam === tamanho)) return v;
      }
      return null;
    }

    var cards = Array.prototype.map.call(raiz.querySelectorAll('[data-cp-card]'), function (el, ordem) {
      var pecas = el.getAttribute('data-cp-pecas').split('|').map(function (par) {
        var i = par.indexOf(':');
        return { chave: par.slice(0, i), cor: par.slice(i + 1).trim(), marcada: true, roupao: 'M' };
      }).filter(function (p) { return p.cor !== ''; });
      return {
        el: el,
        ordem: ordem,
        tipo: el.getAttribute('data-cp-tipo'),
        nome: el.getAttribute('data-cp-nome'),
        pecas: pecas,
        lista: el.querySelector('[data-cp-lista]'),
        total: el.querySelector('[data-cp-total]'),
        rotulo: el.querySelector('[data-cp-total-rotulo]'),
        rotuloBase: (el.querySelector('[data-cp-total-rotulo]') || {}).textContent || '',
        seloDesconto: el.querySelector('[data-cp-selo-desconto]'),
        botao: el.querySelector('[data-cp-comprar]'),
        erro: el.querySelector('[data-cp-erro]')
      };
    });

    function resolver(card, peca) {
      var tam = null;
      if (MAPA_TAMANHO[peca.chave]) tam = MAPA_TAMANHO[peca.chave][estado.tamanho];
      else if (peca.chave === 'roupao') tam = peca.roupao;
      return acharVariante(peca.chave, peca.cor, tam);
    }

    function desenharCard(card) {
      var total = 0;
      var noCarrinho = 0;
      var disponiveis = 0;
      var removidas = 0;
      var cheio = 0;
      card.lista.innerHTML = '';

      var noPedido = {};
      card.pecas.forEach(function (peca) {
        var vp = resolver(card, peca);
        if (peca.marcada && vp && vp.disp) noPedido[peca.chave] = true;
      });
      var comDesconto = {};
      GRUPOS_DESCONTO.forEach(function (grupo) {
        var dentro = grupo.filter(function (c) { return noPedido[c]; });
        if (dentro.length >= 2) dentro.forEach(function (c) { comDesconto[c] = true; });
      });

      card.pecas.forEach(function (peca) {
        var v = resolver(card, peca);
        var disp = !!(v && v.disp);
        var desc = disp && peca.marcada && comDesconto[peca.chave];
        var precoFinal = disp ? (desc ? comFaixa(v.preco) : v.preco) : 0;
        var produto = dados.produtos[peca.chave] || {};
        var cores = COR_PT[peca.cor];
        var corPt = cores ? cores[FEMININO[peca.chave] ? 1 : 0] : peca.cor;
        var hex = (produto.swatches && produto.swatches[peca.cor]) || '';

        if (disp) {
          disponiveis++;
          if (peca.marcada) { total += precoFinal; cheio += v.preco; noCarrinho++; } else { removidas++; }
        }

        var li = document.createElement('li');
        li.className = 'cp-peca' + (disp ? '' : ' cp-peca--esgotada') + (disp && !peca.marcada ? ' cp-peca--removida' : '');

        var bolinha = document.createElement('span');
        bolinha.className = 'cp-peca__cor';
        if (hex) bolinha.style.background = hex;
        li.appendChild(bolinha);

        var info = document.createElement('div');
        info.className = 'cp-peca__info';
        var nome = document.createElement('span');
        nome.className = 'cp-peca__nome';
        nome.textContent = (NOME_PECA[peca.chave] || peca.chave) + ' ' + corPt;
        info.appendChild(nome);
        var detalhe = document.createElement('span');
        detalhe.className = 'cp-peca__detalhe';
        var tamTexto = v && v.tam ? v.tam : (MAPA_TAMANHO[peca.chave] ? MAPA_TAMANHO[peca.chave][estado.tamanho] : '');
        if (peca.chave === 'fronha' && tamTexto) tamTexto = 'Tamanho ' + tamTexto;
        detalhe.textContent = peca.cor + (tamTexto && peca.chave !== 'roupao' ? ' · ' + tamTexto : '');
        info.appendChild(detalhe);

        if (peca.chave === 'roupao') {
          var sel = document.createElement('select');
          sel.className = 'cp-peca__select';
          sel.setAttribute('aria-label', 'Tamanho do roupão');
          TAMANHOS_ROUPAO.forEach(function (t) {
            var vt = acharVariante('roupao', peca.cor, t);
            var o = document.createElement('option');
            o.value = t;
            o.textContent = t + (vt && vt.disp ? '' : ' (esgotado)');
            if (t === peca.roupao) o.selected = true;
            sel.appendChild(o);
          });
          sel.addEventListener('change', function () {
            peca.roupao = sel.value;
            desenharCard(card);
          });
          info.appendChild(sel);
        }
        li.appendChild(info);

        var preco = document.createElement('span');
        preco.className = 'cp-peca__preco';
        if (desc) {
          var de = document.createElement('s');
          de.className = 'cp-preco-de';
          de.textContent = dinheiro(v.preco);
          preco.appendChild(de);
          preco.appendChild(document.createTextNode(dinheiro(precoFinal)));
        } else {
          preco.textContent = disp ? dinheiro(v.preco) : 'Esgotado';
        }
        li.appendChild(preco);

        var alternar = document.createElement('button');
        alternar.type = 'button';
        alternar.className = 'cp-peca__alternar';
        if (!disp) {
          alternar.disabled = true;
          alternar.textContent = '×';
          alternar.setAttribute('aria-label', 'Peça esgotada');
        } else {
          alternar.textContent = peca.marcada ? '×' : '+';
          alternar.setAttribute('aria-label', (peca.marcada ? 'Tirar ' : 'Voltar ') + nome.textContent);
          alternar.addEventListener('click', function () {
            peca.marcada = !peca.marcada;
            if (!peca.marcada) {
              evento('camas_prontas_remover_peca', { combinacao: card.nome, peca: peca.chave, cor: peca.cor, tamanho: estado.tamanho });
            }
            desenharCard(card);
          });
        }
        li.appendChild(alternar);
        card.lista.appendChild(li);
      });

      var temDesconto = total < cheio;
      var totalExibido = temDesconto ? Math.round(total * (100 - PCT_PIX) / 100) : total;
      card.total.textContent = '';
      if (temDesconto) {
        var totalDe = document.createElement('s');
        totalDe.className = 'cp-preco-de';
        totalDe.textContent = dinheiro(cheio);
        card.total.appendChild(totalDe);
      }
      card.total.appendChild(document.createTextNode(dinheiro(totalExibido)));
      if (card.rotulo) card.rotulo.textContent = card.rotuloBase + (temDesconto ? ' no Pix' : '');
      if (card.seloDesconto) card.seloDesconto.hidden = !temDesconto;
      card.disponiveis = disponiveis;
      card.itens = noCarrinho;
      card.valor = total;
      card.botao.disabled = noCarrinho === 0;
      if (disponiveis === 0) card.botao.textContent = 'Indisponível no momento';
      else if (noCarrinho === 0) card.botao.textContent = 'Escolha ao menos uma peça';
      else if (removidas > 0) card.botao.textContent = 'Comprar as peças escolhidas';
      else if (disponiveis < card.pecas.length) card.botao.textContent = 'Comprar as peças disponíveis';
      else card.botao.textContent = 'Comprar a combinação completa';
      card.erro.hidden = true;
    }

    /* Regra da página: combinação com estoque fica em cima. Completas primeiro, depois as que têm
       mais peças disponíveis no tamanho escolhido; empate mantém a ordem do editor. */
    function ordenarPorEstoque() {
      cards.slice().sort(function (a, b) {
        var ca = a.disponiveis === a.pecas.length ? 0 : 1;
        var cb = b.disponiveis === b.pecas.length ? 0 : 1;
        return (ca - cb) || (b.disponiveis - a.disponiveis) || (a.ordem - b.ordem);
      }).forEach(function (card) {
        card.el.parentNode.appendChild(card.el);
      });
    }

    function desenharTudo() {
      cards.forEach(desenharCard);
      ordenarPorEstoque();
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-cp-tamanho]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cp-tamanho') === estado.tamanho ? 'true' : 'false');
      });
    }

    function aplicarFiltro() {
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-cp-filtro]'), function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cp-filtro') === estado.filtro ? 'true' : 'false');
      });
      var f = estado.filtro;
      cards.forEach(function (c) {
        var tag = c.el.getAttribute('data-cp-filtro-card');
        c.el.hidden = !(f === 'todas' || f === tag);
      });
      Array.prototype.forEach.call(raiz.querySelectorAll('[data-cp-secao]'), function (s) {
        var tipo = s.getAttribute('data-cp-secao');
        s.hidden = f === 'todas' ? false : (f === 'banho' ? tipo !== 'banho' : tipo !== 'camas');
      });
    }

    raiz.addEventListener('click', function (e) {
      var bt = e.target.closest('[data-cp-tamanho]');
      if (bt) {
        var t = bt.getAttribute('data-cp-tamanho');
        if (t !== estado.tamanho) {
          estado.tamanho = t;
          gravarTamanho(t);
          evento('camas_prontas_tamanho', { tamanho: t });
          desenharTudo();
        }
        return;
      }
      var bf = e.target.closest('[data-cp-filtro]');
      if (bf) {
        estado.filtro = bf.getAttribute('data-cp-filtro');
        aplicarFiltro();
      }
    });

    cards.forEach(function (card) {
      card.botao.addEventListener('click', function () {
        var itens = [];
        card.pecas.forEach(function (peca) {
          var v = resolver(card, peca);
          if (peca.marcada && v && v.disp) itens.push({ id: v.id, quantity: 1 });
        });
        if (!itens.length) return;
        card.botao.disabled = true;
        card.botao.setAttribute('aria-busy', 'true');
        evento('camas_prontas_comprar', {
          combinacao: card.nome,
          tamanho: card.tipo === 'cama' ? estado.tamanho : '',
          pecas: itens.length,
          valor: card.valor / 100
        });
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: itens })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Erro ao adicionar'); });
          var destino = '/checkout';
          if (dados.mostrarCupom && dados.cupom) destino += '?discount=' + encodeURIComponent(dados.cupom);
          window.location.href = destino;
        }).catch(function (err) {
          card.botao.disabled = false;
          card.botao.removeAttribute('aria-busy');
          card.erro.textContent = 'Não conseguimos adicionar agora: ' + err.message + '. Atualize a página e tente de novo.';
          card.erro.hidden = false;
        });
      });
    });

    desenharTudo();
    aplicarFiltro();
    raiz.setAttribute('data-cp-pronto', 'true');
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-camas-prontas]'), iniciar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
